export var SupportedLocale;
(function (SupportedLocale) {
    SupportedLocale["En"] = "en";
    SupportedLocale["Gb"] = "en_GB";
    SupportedLocale["Us"] = "en_US";
    SupportedLocale["Fr"] = "fr";
    SupportedLocale["De"] = "de";
    SupportedLocale["Es"] = "es";
    SupportedLocale["Ja"] = "ja";
    SupportedLocale["It"] = "it";
})(SupportedLocale || (SupportedLocale = {}));
//# sourceMappingURL=locales.js.map